/*  Accordion toggle functionality
 *
 * @file combined
 */

const Accordion = {
    classes: {
        containerClass: '.rs-accordion', // accordion parent class.
        rowClass: '.rs-accordion__row', // accordion container class.
        toggleClass: 'rs-accordion__heading', // accordion toggle class.
        singleOpenClass: 'rs-accordion__accordions--single-open', // accordion class for single-open
        activeClass: 'is_active', // accordion active class
    },

    toggle: () => {
        document.addEventListener('click', e => {
            // If the clicked element doesn't have the right selector, bail.
            if (!e.target.classList.contains(Accordion.classes.toggleClass)) {
                return;
            }
            e.preventDefault();
            Accordion.handleClick(e.target);
        }, false);
    },

    swapImage: (num) => {
        // Get array of images
        const accordionImages = Array.from(document.querySelectorAll('[data-accordionimage]'));

        // Loop through images and remove the active class if it exists
        accordionImages.forEach((image) => {
            if (image.classList.contains('is_active')) {
                image.classList.remove('is_active');
            }
        });

        // Grab the image that matches our active accordion row
        const image = accordionImages[num];

        // Set this image to active
        image.classList.add('is_active');
    },

    handleClick: (clickedElement) => {
        const isActive = clickedElement.parentElement.classList.contains('is_active');
        const clickedRow = clickedElement.closest(Accordion.classes.rowClass);
        const parentContainer = clickedRow.closest(Accordion.classes.containerClass);

        if (isActive) {
            clickedElement.nextElementSibling.style.overflowY = 'hidden';
        } else {
            setTimeout(() => {
                clickedElement.nextElementSibling.style.overflowY = 'auto';
            }, 300);
        }

        clickedRow.classList.toggle(Accordion.classes.activeClass);

        // Check to see if accordion is gallery type
        const gallery = (clickedRow.parentNode.dataset.accordion === 'gallery');
        // If the accordion is a gallery type and a data-row exists
        if (gallery && clickedRow.dataset.row) {
            // Get the row number
            const accordionRow = clickedRow.dataset.row;
            // Pass the row number to our swapImage function
            Accordion.swapImage(accordionRow);
        }

        if (parentContainer.classList.contains(Accordion.classes.singleOpenClass)) {
            const siblingRows = parentContainer.children;
            for (const sibling of siblingRows) {
                if (sibling.nodeType === 1 && sibling !== clickedRow) {
                    sibling.classList.remove(Accordion.classes.activeClass);
                }
            }
        }
    },
};

export default Accordion;
